import { call, put, select } from 'redux-saga/effects';
import { actions as errorActions } from '@/reducers/error-reducer';
import { normalizeErrorInfo } from '@/sagas/normalizers/errorNormalizer';
import { getClientsIds } from '@/sagas/utils/clientIdsUtils';
import { recaptchaActions } from '@/sagas/utils/recaptchaUtils';
import { reportJSError } from '@/utils/common';
import sendRetargeting from '@/services/retargeting';
import getReCaptchaToken from '@/services/recaptcha';
import { WEB_SERVICES } from '@/errorManagement/utils';
import { actions as formActions } from '@/reducers/form-baf-reducer';
import getUrlParams from '@gcloud-npm/utils.common.get-url-params';
import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import { getToken } from '@gcloud-npm/utils.recaptcha.get-token';

const context = (state) => state.main.context;
const contextZone = (state) => state.main.zone;

export function* retargeting({ payload }) {
  const contextApi = yield select(context);
  try {
    const zone = yield select(contextZone);
    const { contextURL, userIdPartyHash } = { ...contextApi };
    if (userIdPartyHash) {
      const { data } = payload;
      const {
        telcoProductName,
        telcoProductOfferingId,
        telcoPromotionId,
        lastTelcoProductOfferingId,
        campaignId,
      } = {
        ...data,
      };
      const { telcoCharacteristicId, telcoCharacteristicValue } = {
        ...getUrlParams({
          groupByObject: false,
          allowedParams: false,
          excludeHash: true,
          currentUrl: window.location.href,
        }),
      };
      if (telcoProductOfferingId !== lastTelcoProductOfferingId) {
        const dataPayload = {
          campaign: {
            id: campaignId,
          },
          products: [
            {
              productOfferingId: telcoProductOfferingId || '',
              productName: telcoProductName || '',
              promotion: {
                promotionId: telcoPromotionId || '',
              },
            },
          ],
          context: {
            url: btoa(zone ? `${contextURL}&zone=${zone}` : contextURL),
            ga: getClientsIds(contextApi),
          },
          contactInfo: {
            encryptedPartyId: userIdPartyHash || '',
          },
          requestId: getUUID('', '', false),
        };
        if (telcoCharacteristicId && telcoCharacteristicValue) {
          dataPayload.products[0] = {
            ...dataPayload.products[0],
            characteristics: [
              {
                id: telcoCharacteristicId,
                value: telcoCharacteristicValue,
              },
            ],
          };
        }
        const recaptchaToken = yield call(getToken, {
          action: recaptchaActions.RETARGETING,
          recaptchaId: process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID,
        });
        yield call(sendRetargeting, {
          data: dataPayload,
          recaptchaToken,
          context: contextApi,
        });
      }
    }
  } catch (error) {
    reportJSError(error, 'retargeting', 'sagas/retargeting-sagas', contextApi);
    const errorInfo = normalizeErrorInfo(
      error,
      WEB_SERVICES.RETARGETING,
      contextApi
    );
    yield put(errorActions.setError(errorInfo));
  }
}

export function* studentRetargeting({ payload }) {
  const contextApi = yield select(context);
  try {
    const { contextURL } = { ...contextApi };
    const { data } = payload;
    const {
      telcoProductOfferingId,
      contactEmail,
      contactPhone,
      studentEmail,
      documentId,
    } = {
      ...data,
    };
    const dataPayload = {
      campaign: {
        id: 'ret-estudiantes-lead',
      },
      products: [
        {
          productName: telcoProductOfferingId,
        },
      ],
      context: {
        url: btoa(contextURL),
        ga: getClientsIds(contextApi),
      },
      contactInfo: {
        document: documentId,
        email: contactEmail,
        phone: contactPhone,
      },
      additionalInfo: `{"emailEstudiante":"${studentEmail}"}`,
    };
    const recaptchaToken = yield call(getReCaptchaToken, {
      action: recaptchaActions.RETARGETING,
    });
    yield call(sendRetargeting, {
      data: dataPayload,
      recaptchaToken,
      context: contextApi,
    });
    yield put(formActions.sendStudentRetargetingSuccess());
  } catch (error) {
    reportJSError(
      error,
      'retargeting-student',
      'sagas/retargeting-sagas',
      contextApi
    );
    const errorInfo = normalizeErrorInfo(
      error,
      WEB_SERVICES.RETARGETING,
      contextApi
    );
    yield put(formActions.sendStudentRetargetingFail());
    yield put(errorActions.setError(errorInfo));
  }
}
